import { tPatientService } from './../../services/tPatient.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tBillPayModel, BillPay_Patient_PackageModel, BillPay_ItemType, PatientRelative_PackageModel, BillPayPaymenyByItemPackageModel } from 'src/app/models/tBillPayModel';
import { AppComponent } from 'src/app/app.component';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { SpecialPaymentMethod } from 'src/app/models/non-master-model/SpecialPaymentMethod';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { StatusMessage } from 'src/app/shared/StatusMessage';

@Component({
  selector: 'app-patient-package-dialog',
  templateUrl: './patient-package-dialog.component.html',
  styleUrls: ['./patient-package-dialog.component.css']
})
export class PatientPackageDialogComponent implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private log: LoggerService,
    private tBillPayService: tBillPayService,
    private dateTimeConvertService: DateTimeConvertService,
    private apiResultHandlerService: ApiResultHandlerService,
    private tPatientService: tPatientService,
    private apiResultDialogService: ApiResultDialogService

  ) { }

  private TAG = "PatientPackageDialogComponent";

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);
    this.getAllData();
  }

  dataSource: MatTableDataSource<BillPay_Patient_PackageModel>;
  dataList: BillPay_Patient_PackageModel[];
  @ViewChild(MatSort) sort: MatSort;


  @Input() patientID: string;
  @Input() invoiceID: string;
  @Input() selectedBillPayModel: tBillPayModel;


  //loading spinner
  isLoading = true;
  onClickCounter=0;


  displayedColumns: string[] = [
    'cPackageID',
    'packDescAll',
    'expirationDate',

    'packageRemaining',
    'patientName',
    // 'actionColumn'

  ];




  getAllData() {

    this.getPatientPackage();
  }


  getPatientPackage(): void {
    this.log.i(this.TAG, ' getPatientPackage patientID = ' + this.patientID);

    this.tBillPayService.getPatientPacketByItemID(this.patientID, this.selectedBillPayModel.bpItemID).subscribe(data => {

      var allPatientRelative_PackageModel: PatientRelative_PackageModel = data;

      var allPackage: BillPay_Patient_PackageModel[] = new Array;

      if (allPatientRelative_PackageModel.selfpackage != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.selfpackage.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.selfpackage[p]);
        }
      }

      if (allPatientRelative_PackageModel.otherPatientPackage != null) {
        for (var p = 0; p < allPatientRelative_PackageModel.otherPatientPackage.length; p++) {
          allPackage.push(allPatientRelative_PackageModel.otherPatientPackage[p]);
        }
      }

      // allPackage.push(allPatientRelative_PackageModel.otherPatientPackage);

      this.dataSource = new MatTableDataSource<BillPay_Patient_PackageModel>(allPackage);
      this.dataList = allPackage;

      this.log.i(this.TAG, "getPatientPacket data = " + JSON.stringify(data) + " , this dataList = " + allPatientRelative_PackageModel.selfpackage.length
        + " , 2 = " + allPatientRelative_PackageModel.otherPatientPackage.length);

      //loading spinner
      this.isLoading = false;
      //table sort
      this.dataSource.sort = this.sort;

    },
      error => this.isLoading = false);
  }

  setDefaultLanguageString(language: String) {
    
  }


  formatDate(date: string) {
    const newDate = new Date(date);
    return this.dateTimeConvertService.ConvertCurrentDay(newDate);
  }



  selectedPackageRecord(selectedModel: BillPay_Patient_PackageModel) {

    if(this.onClickCounter==0){
    // this.confirmSubmitDataToSerer(selectedModel);


    this.openAPI_Result_Model(MastersKeyStringValue.ACTION_BillpayConfirmPackage, "是否確認使用")
    .result.then((result) => {
        this.log.i(this.TAG, 'ACTION_BillpayConfirmPackage openAPI_Result_Model result = ' + result);
       this.confirmSubmitDataToSerer(selectedModel);
      //  this.activeModal.close('Ok');

      }, (reason) => {
        this.log.i(this.TAG, 'ACTION_BillpayConfirmPackage openAPI_Result_Model reason = ' + reason);
        // this.confirmSubmitDataToSerer(selectedModel);
        // this.activeModal.close('Ok');
      });

    }



  }

  openAPI_Result_Model(status, msg) {
    this.log.i(this.TAG, 'openConfirmModal action = ' + status);

    return this.apiResultDialogService.openDialog(status, '', status, msg);
  }


  confirmSubmitDataToSerer(selectedModel: BillPay_Patient_PackageModel) {

    this.log.i(this.TAG, "invoiceID = " + this.invoiceID);
    // grouup the data and send to server
    var shopID: string = NavigationComponent.selectedShopID.toString();
    var bpInvoiceNumber: string = this.invoiceID;
    var bpLineNumber: number = 1;
    var bpPaymentNumber: string = SpecialPaymentMethod.Package.toString();
    var bpDateTime: Date = null;
    var bpPatientID: string = selectedModel.billPay.bpPatientID;
    var bpChangeID: string = null;
    var bpConsultNumber: string = null;
    var bpItemID: string = null;
    var bpItemType: string = BillPay_ItemType.PAYMENT;
    var bpItemDesc: string = null;
    var bpQty: number = null;
    var bpStandardPrice: number = null;

    var bpFinalPrice: number = null;
    var bpLineAmount: number = null;
    // var packItemID : string = selectedModel.packageInfo.packItemID;

    var bpArAmount: number = null;

    var bpPackInvoiceNo: string = selectedModel.billPay.bpPackInvoiceNo;
    var bpPackItemID: string = selectedModel.packageInfo.packItemID;
    var bpPackageQty: number = this.selectedBillPayModel.bpQty * -1;
    var bpPackFaceAmt: number = null;
    var bpPackID: string = selectedModel.packageInfo.packID;
    console.log("bpPackID = " + bpPackID);
    var bpPaymentMethodName: string = selectedModel.packageInfo.packDesc;
    var bpRemark: string = null;
    var bpRemark2: string = null;
    var bpRemark3: string = null;
    var bpRemark4: string = null;
    var bpRemark5: string = null;

    var bpPackDesc: string = selectedModel.packageInfo.packDesc;
    var bpPackDis: string = selectedModel.packageInfo.packDisc.toString();
    var bpPackPatientID: string = selectedModel.billPay.bpPatientID;

    var bpPaymentRemark: string = null;

    var inActive: string = "N";
    var lastModifyDatetime: Date = null;
    var lastModifyUserID: string = NavigationComponent.userID;

    //check ar amount should be 
    if (selectedModel.remainder > 0) {
      // this package using qty 
      //when package using Qty -> compare package's qty and item's qty
      bpArAmount = this.selectedBillPayModel.bpArAmount;


    } else {
      // this package using amount 
      //when package using amount -> compare package's remainer and item's arAmount

      // var packageRemainer = selectedModel.packageInfo.packFaceAmt;

    }



    var bpEmployeeID: string = null;
    var bpPrintName: string = null;
    var bpPaymentMethodID: string = SpecialPaymentMethod.Package.toString();

    var paymentName: string = null;





    var newBillPay = new tBillPayModel();
    newBillPay.shopID = shopID;
    newBillPay.bpInvoiceNumber = bpInvoiceNumber;
    newBillPay.bpLineNumber = bpLineNumber;
    newBillPay.bpPaymentNumber = bpPaymentNumber;
    newBillPay.bpDateTime = bpDateTime;
    newBillPay.bpPatientID = bpPatientID;
    newBillPay.bpChangeID = bpChangeID;
    newBillPay.bpConsultNumber = bpConsultNumber;
    newBillPay.bpItemID = bpItemID;
    newBillPay.bpItemType = bpItemType;
    newBillPay.bpItemDesc = bpItemDesc;
    newBillPay.bpQty = bpQty;
    newBillPay.bpStandardPrice = bpStandardPrice;
    newBillPay.bpFinalPrice = bpFinalPrice;
    newBillPay.bpLineAmount = bpLineAmount;
    newBillPay.bpArAmount = bpArAmount * -1;
    newBillPay.bpPackInvoiceNo = bpPackInvoiceNo;
    newBillPay.bpPackItemID = bpPackItemID;
    newBillPay.bpPackageQty = bpPackageQty;
    newBillPay.bpPackFaceAmt = bpPackFaceAmt;

    newBillPay.bpPackID = bpPackID;
    newBillPay.bpItemID = bpItemID;

    newBillPay.bpEmployeeID = bpEmployeeID;
    newBillPay.bpPrintName = bpPrintName;
    newBillPay.bpPaymentMethodID = bpPaymentMethodID;
    newBillPay.bpPaymentMethodName = bpPaymentMethodName;
    newBillPay.bpRemark = bpRemark;
    newBillPay.bpRemark2 = bpRemark2;
    newBillPay.bpRemark3 = bpRemark3;
    newBillPay.bpRemark4 = bpRemark4;
    newBillPay.bpRemark5 = bpRemark5;

    newBillPay.bpPackDesc = selectedModel.packageInfo.packDesc;
    newBillPay.bpPackDis = selectedModel.packageInfo.packDisc.toString();
    newBillPay.bpPackPatientID = selectedModel.billPay.bpPatientID;


    newBillPay.bpPaymentRemark = bpPaymentRemark;
    newBillPay.inActive = inActive;
    newBillPay.lastModifyDatetime = lastModifyDatetime;
    newBillPay.lastModifyUserID = lastModifyUserID;

    this.log.i(this.TAG, " newBillPay = " + JSON.stringify(newBillPay));

    var paymentByItemPackageModel: BillPayPaymenyByItemPackageModel = new BillPayPaymenyByItemPackageModel;

    this.selectedBillPayModel.bpPackDesc = selectedModel.packageInfo.packDesc;
    this.selectedBillPayModel.bpPackDis = selectedModel.packageInfo.packDisc.toString();
    this.selectedBillPayModel.bpPackPatientID = selectedModel.billPay.bpPatientID;


    paymentByItemPackageModel.itemRecord = this.selectedBillPayModel;
    paymentByItemPackageModel.paymentRecord = newBillPay;

    //selectedBillPayModel
    this.tBillPayService.paymentByItemPackage(paymentByItemPackageModel)
      .subscribe(

        (data: any) => {


          if (data.statusCode === StatusMessage.Status_Package_Used) {
            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog, '已有套票使用記錄, 不作扣除');
          }else

          if (data.statusCode === StatusMessage.Status_Package_OverUsed) {
            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog,
              '扣套票要求已超過服務數量, 不作扣除; 請註銷 ' + paymentByItemPackageModel.itemRecord.bpInvoiceNumber + ' 的付款號碼重置扣套票');
          }else if(data.statusCode === StatusMessage.Status_Package_Required_Over){
            this.openAPI_Result_Model(MastersKeyStringValue.ACTION_MessageDialog,
              '扣套票:' + paymentByItemPackageModel.itemRecord.bpInvoiceNumber + '-扣除數量超過可用數量 , 請檢查');
          }





          this.log.i(this.TAG, 'onSubmit success');

          this.activeModal.close(data);
          this.log.i(this.TAG, "do confirm data = " + JSON.stringify(data));

        },
        err => {
          this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));

          this.apiResultHandlerService.ErrHandler();

        });
        this.onClickCounter++;
  }


}
